module.exports = __webpack_public_path__ + "static/media/giochibambini.8a602889.jpg";